(function () {
  'use strict';

  // Taal en markt-valuta uit de i18n-bridge (snippets/theme-i18n-strings.liquid).
  // Zonder bridge valt alles terug op de Nederlandse opmaak in euro's.
  var ADQ_LOCALE = (window.theme && window.theme.locale) || 'nl-NL';
  var ADQ_VALUTA = (window.theme && window.theme.currency) || 'EUR';

  // i18n-bridge: vertaalde strings uit window.theme.i18n (gevuld inline in de
  // sectie vóór dit script). Valt terug op de NL-string als de bridge ontbreekt.
  var t = (window.theme && window.theme.t) || function (k, f) { return f || ''; };

  var TARGET_SELECTOR = '[bss-b2b-qb-product-table], .bss-b2b-cart-item-qty-table';
  var ROW_SELECTOR = 'tr.bss-b2b-qty-table-row, tbody tr';
  var PRICE_SELECTOR = '[data-product-price]';
  var REPLACEMENT_CLASS = 'adeqo-staffel adeqo-staffel--bss';
  var REPLACEMENT_MARKER = 'data-adeqo-staffel-rendered';
  var TITLE_TEXT = t('staffel_title', 'Staffelkorting');
  var PRICE_COL_LABEL = t('staffel_price_per_panel', 'Prijs per paneel');
  var M2_COL_LABEL = t('staffel_price_per_m2', 'Prijs per m²');

  function escapeHTML(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : String(s);
    return div.innerHTML;
  }

  function isOpenEnded(text) {
    return /[≥>]/.test(text);
  }

  function readTiers(container) {
    var rows = container.querySelectorAll(ROW_SELECTOR);
    if (rows.length === 0) return [];
    var tiers = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('th')) continue;
      var cells = row.querySelectorAll('td');
      if (cells.length < 2) continue;
      var rangeText = (cells[0].textContent || '').trim().replace(/\s+/g, ' ');
      var discountText = (cells[cells.length - 1].textContent || '').trim().replace(/\s+/g, ' ');
      if (!rangeText || !discountText) continue;

      var min = parseInt(row.getAttribute('data-min'), 10);
      var max = parseInt(row.getAttribute('data-max'), 10);
      if (isNaN(min)) min = 0;
      if (isNaN(max)) max = Infinity;
      if (isOpenEnded(rangeText)) max = Infinity;

      var discountPct = parseFloat(discountText.replace(',', '.')) || 0;

      tiers.push({
        range: rangeText,
        discount: discountText,
        discountPct: discountPct,
        min: min,
        max: max
      });
    }
    return tiers;
  }

  function findVisiblePriceEl() {
    var selectors = [
      '.adeqo-product-info__price-wrapper[bss-b2b-product-active="true"] .bss-b2b-price-no-vat',
      '.adeqo-product-info__price-wrapper[bss-b2b-product-active="true"] .bss-b2b-price-vat',
      '.adeqo-product-info__price-wrapper[bss-b2b-product-active="true"] span',
      '.bss-b2b-price-no-vat',
      '.bss-b2b-price-vat',
      '[bss-b2b-variant-price]',
      '[data-product-price]',
      '.adeqo-product-info__price',
      '.adeqo-product-info__price-wrapper .adeqo-product-info__price',
      '[data-product-price-amount]',
      '.adeqo-product-info__size-option.is-current .adeqo-product-info__size-price',
      '.adeqo-product-info__size-option.current .adeqo-product-info__size-price'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var els = document.querySelectorAll(selectors[s]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.offsetParent !== null && parsePrice(el.textContent) != null) return el;
      }
    }
    for (var s2 = 0; s2 < selectors.length; s2++) {
      var fallback = document.querySelector(selectors[s2]);
      if (fallback && parsePrice(fallback.textContent) != null) return fallback;
    }
    return null;
  }

  function getUnitPriceFallback() {
    var el = document.querySelector('[data-unit-price]');
    if (!el) return null;
    var cents = parseInt(el.getAttribute('data-unit-price'), 10);
    if (isNaN(cents) || cents <= 0) return null;
    return cents / 100;
  }

  function getM2PerPaneel() {
    var el = document.querySelector('[data-m2-per-paneel]');
    if (!el) return null;
    var raw = (el.getAttribute('data-m2-per-paneel') || '').replace(',', '.');
    var val = parseFloat(raw);
    return isNaN(val) || val <= 0 ? null : val;
  }

  function parsePrice(text) {
    if (!text) return null;
    var clean = text.replace(/[^\d,.\-]/g, '').trim();
    if (!clean) return null;
    // NL format: 1.234,56  or  95,00  — strip thousand dots, comma is decimal
    var hasComma = clean.indexOf(',') !== -1;
    if (hasComma) {
      clean = clean.replace(/\./g, '').replace(',', '.');
    }
    var num = parseFloat(clean);
    return isNaN(num) ? null : num;
  }

  function formatPrice(amount) {
    if (amount == null || isNaN(amount)) return '';
    // Winkelformaat (shop.money_format) via de i18n-bridge, gelijk aan de Liquid-prijzen.
    if (window.theme && window.theme.money) return window.theme.money(Math.round(amount * 100));
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(ADQ_LOCALE, {
          style: 'currency',
          currency: ADQ_VALUTA,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e) { /* fall through */ }
    }
    return '€' + amount.toFixed(2).replace('.', ',');
  }

  function getBlockConfig(container) {
    var block = container.closest ? container.closest('[data-bss-staffel]') : null;
    if (!block) return null;
    return {
      titel: block.getAttribute('data-staffel-titel') || null,
      kolAantal: block.getAttribute('data-staffel-kol-aantal') || null,
      kolPrijs: block.getAttribute('data-staffel-kol-prijs') || null,
      kolM2: block.getAttribute('data-staffel-kol-m2') || null,
      kolKorting: block.getAttribute('data-staffel-kol-korting') || null
    };
  }

  function buildHTML(tiers, basePrice, m2PerPaneel, config) {
    var titel = (config && config.titel) || TITLE_TEXT;
    var labelAantal = (config && config.kolAantal) || 'Aantal';
    var labelPrijs = (config && config.kolPrijs) || PRICE_COL_LABEL;
    var labelM2 = (config && config.kolM2) || M2_COL_LABEL;
    var labelKorting = (config && config.kolKorting) || 'Korting';

    var showPriceCol = basePrice != null;
    var showM2Col = showPriceCol && m2PerPaneel != null;
    var rowsHTML = tiers.map(function (t) {
      var maxAttr = t.max === Infinity ? '' : t.max;
      var discounted = showPriceCol ? basePrice * (1 - t.discountPct / 100) : null;
      var priceCell = showPriceCol
        ? '<td class="adeqo-staffel__price-cell" data-price-cell>' + escapeHTML(formatPrice(discounted)) + '</td>'
        : '';
      var m2Cell = showM2Col
        ? '<td class="adeqo-staffel__price-cell adeqo-staffel__m2-cell" data-m2-cell>' + escapeHTML(formatPrice(discounted / m2PerPaneel)) + '</td>'
        : '';
      return '<tr data-min="' + t.min + '" data-max="' + maxAttr + '" data-discount="' + t.discountPct + '">' +
        '<td><span class="adeqo-staffel__radio"></span>' + escapeHTML(t.range) + '</td>' +
        priceCell + m2Cell +
        '<td><span class="adeqo-staffel__discount">' + escapeHTML(t.discount) + '</span></td>' +
        '</tr>';
    }).join('');

    var headerCells = ['<th>' + escapeHTML(labelAantal) + '</th>'];
    if (showPriceCol) headerCells.push('<th>' + escapeHTML(labelPrijs) + '</th>');
    if (showM2Col) headerCells.push('<th>' + escapeHTML(labelM2) + '</th>');
    headerCells.push('<th>' + escapeHTML(labelKorting) + '</th>');
    var headHTML = '<tr>' + headerCells.join('') + '</tr>';

    return '' +
      '<div class="adeqo-staffel__title">' + escapeHTML(titel) + '</div>' +
      '<table class="adeqo-staffel__table">' +
        '<thead>' + headHTML + '</thead>' +
        '<tbody>' + rowsHTML + '</tbody>' +
      '</table>';
  }

  function findQuantityInput() {
    var selectors = [
      '[data-qty-select]',
      '.adeqo-purchase-row__qty-input',
      '.adeqo-product-info__quantity-input',
      'input[name="quantity"]',
      'quantity-input input',
      '[data-quantity-input]',
      '.adeqo-purchase-row__qty input[type="number"]',
      '.adeqo-product-info__quantity input[type="number"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        if (els[j].offsetParent !== null) return els[j];
      }
    }
    for (var k = 0; k < selectors.length; k++) {
      var fallback = document.querySelector(selectors[k]);
      if (fallback) return fallback;
    }
    return null;
  }

  function injectClickStyles() {
    if (document.getElementById('adeqo-staffel-bss-style')) return;
    var style = document.createElement('style');
    style.id = 'adeqo-staffel-bss-style';
    style.textContent =
      '.adeqo-staffel--bss{margin-top:24px}' +
      '.adeqo-staffel--bss .adeqo-staffel__title{margin-bottom:12px}' +
      '.adeqo-staffel--bss tbody tr{cursor:pointer;transition:background-color .15s ease}' +
      '.adeqo-staffel--bss tbody tr:hover{background-color:#fafafa}' +
      '.adeqo-staffel--bss tbody tr:hover .adeqo-staffel__radio{border-color:var(--product-accent)}' +
      '.adeqo-staffel__suffix{font-size:.55em;font-weight:400;color:#999;margin-left:6px;letter-spacing:.01em;vertical-align:middle}';
    document.head.appendChild(style);
  }

  function attachClickHandlers(wrapper) {
    wrapper.addEventListener('click', function (e) {
      var row = e.target.closest ? e.target.closest('tbody tr') : null;
      if (!row || !wrapper.contains(row)) return;

      var qtyInput = findQuantityInput();
      if (!qtyInput) return;

      var maxAttr = row.getAttribute('data-max');
      var minAttr = row.getAttribute('data-min');
      var target;
      if (maxAttr === '' || maxAttr == null) {
        target = parseInt(minAttr, 10) || 1;
      } else {
        target = parseInt(maxAttr, 10);
      }
      if (isNaN(target) || target < 1) target = 1;

      var nativeMax = parseInt(qtyInput.getAttribute('max'), 10);
      if (!isNaN(nativeMax) && target > nativeMax) target = nativeMax;

      qtyInput.value = String(target);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncActive(wrapper, mainPriceCtx) {
    var qtyInput = findQuantityInput();
    var rows = wrapper.querySelectorAll('tbody tr');

    function update() {
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      rows.forEach(function (row) {
        var min = parseInt(row.getAttribute('data-min'), 10) || 0;
        var maxAttr = row.getAttribute('data-max');
        var max = maxAttr === '' || maxAttr == null ? Infinity : parseInt(maxAttr, 10);
        var active = qty >= min && qty <= max;
        var radio = row.querySelector('.adeqo-staffel__radio');
        if (active) {
          row.classList.add('is-active');
          if (radio) radio.classList.add('adeqo-staffel__radio--active');
        } else {
          row.classList.remove('is-active');
          if (radio) radio.classList.remove('adeqo-staffel__radio--active');
        }
      });
      if (mainPriceCtx) mainPriceCtx.applyActive();
    }

    update();
    if (qtyInput) {
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
    }
  }

  function syncPrices(wrapper, priceEl, m2PerPaneel, mainPriceCtx) {
    if (!priceEl) return;
    var rows = wrapper.querySelectorAll('tbody tr');

    function readBase() {
      if (mainPriceCtx && mainPriceCtx.basePrice != null) return mainPriceCtx.basePrice;
      var b = parsePrice(priceEl.textContent);
      if (b == null) b = getUnitPriceFallback();
      return b;
    }

    function update() {
      var base = readBase();
      if (base == null) return;
      rows.forEach(function (row) {
        var priceCell = row.querySelector('[data-price-cell]');
        var m2Cell = row.querySelector('[data-m2-cell]');
        var pct = parseFloat(row.getAttribute('data-discount')) || 0;
        var disc = base * (1 - pct / 100);
        if (priceCell) priceCell.textContent = formatPrice(disc);
        if (m2Cell && m2PerPaneel) m2Cell.textContent = formatPrice(disc / m2PerPaneel);
      });

      var noteEl = wrapper.querySelector('[data-staffel-tax-note]');
      var suffix = mainPriceCtx ? (mainPriceCtx.suffix || '') : '';
      var noteText = suffix.replace(/^\s+/, '');
      if (noteText) {
        if (!noteEl) {
          noteEl = document.createElement('div');
          noteEl.className = 'adeqo-staffel__tax-note';
          noteEl.setAttribute('data-staffel-tax-note', '');
          noteEl.style.cssText = 'font-size:11px;color:#888;margin-top:6px;text-align:right;';
          wrapper.appendChild(noteEl);
        }
        noteEl.textContent = t('staffel_all_note', 'Alle prijzen {suffix}').replace('{suffix}', noteText);
      } else if (noteEl) {
        noteEl.parentNode.removeChild(noteEl);
      }
    }

    update();
    if (mainPriceCtx) mainPriceCtx.refreshTable = update;
  }

  var SUFFIX_REGEX = /(excl|incl)[\s\-]?btw/i;

  function buildMainPriceContext(priceEl, tiers, getQty) {
    if (!priceEl) return null;
    var initialText = (priceEl.textContent || '').trim();
    var initialBase = parsePrice(initialText);
    if (initialBase == null) initialBase = getUnitPriceFallback();
    if (initialBase == null) return null;

    var initialSuffix = '';
    var suffixMatch = initialText.match(SUFFIX_REGEX);
    if (suffixMatch) initialSuffix = ' ' + suffixMatch[0];

    var ctx = {
      priceEl: priceEl,
      basePrice: initialBase,
      suffix: initialSuffix,
      lastSetText: null,
      suppressObserver: false,
      refreshTable: null
    };

    function findActivePct() {
      var qty = getQty();
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        if (qty >= t.min && qty <= t.max) return t.discountPct;
      }
      return 0;
    }

    function recaptureIfExternal() {
      var current = (ctx.priceEl.textContent || '').trim();
      if (current === ctx.lastSetText) return false;
      var parsed = parsePrice(current);
      if (parsed == null) return false;
      ctx.basePrice = parsed;
      var m = current.match(SUFFIX_REGEX);
      ctx.suffix = m ? ' ' + m[0] : '';
      return true;
    }

    function apply() {
      var fresh = findVisiblePriceEl();
      if (fresh && fresh !== ctx.priceEl) {
        ctx.priceEl = fresh;
        var t = (fresh.textContent || '').trim();
        var p = parsePrice(t);
        if (p != null) ctx.basePrice = p;
        var m = t.match(SUFFIX_REGEX);
        if (m) ctx.suffix = ' ' + m[0];
        ctx.lastSetText = null;
        if (ctx.refreshTable) ctx.refreshTable();
      } else {
        if (recaptureIfExternal() && ctx.refreshTable) ctx.refreshTable();
      }

      if (ctx.basePrice == null) return;
      var pct = findActivePct();
      var qty = getQty();
      var unitTarget = pct > 0 ? ctx.basePrice * (1 - pct / 100) : ctx.basePrice;

      var formatted = formatPrice(unitTarget);
      var suffix = (ctx.suffix || '').trim();
      var newPlainText = suffix ? formatted + ' ' + suffix : formatted;
      var currentText = (ctx.priceEl.textContent || '').trim();
      var hasSuffixSpan = !!ctx.priceEl.querySelector('.adeqo-staffel__suffix');
      var needsWrap = suffix && !hasSuffixSpan;
      if (currentText !== newPlainText || needsWrap) {
        ctx.suppressObserver = true;
        ctx.lastSetText = newPlainText;
        if (suffix) {
          ctx.priceEl.innerHTML = escapeHTML(formatted) +
            ' <span class="adeqo-staffel__suffix">' + escapeHTML(suffix) + '</span>';
        } else {
          ctx.priceEl.textContent = formatted;
        }
        setTimeout(function () { ctx.suppressObserver = false; }, 0);
      }

      var subtotalEl = document.querySelector('[data-subtotal]');
      if (subtotalEl) {
        var subtotalAmount = formatPrice(unitTarget * qty);
        var subPlainText = suffix ? subtotalAmount + ' ' + suffix : subtotalAmount;
        if ((subtotalEl.textContent || '').trim() !== subPlainText) {
          subtotalEl.textContent = subPlainText;
        }
      }
    }

    ctx.applyActive = apply;

    document.addEventListener('adeqo:quantity-changed', function () {
      apply();
    });

    return ctx;
  }

  function process(container) {
    if (container.hasAttribute(REPLACEMENT_MARKER)) return;
    var tiers = readTiers(container);
    if (tiers.length === 0) return;

    var priceEl = findVisiblePriceEl();
    var basePrice = priceEl ? parsePrice(priceEl.textContent) : null;
    if (basePrice == null) basePrice = getUnitPriceFallback();
    var m2PerPaneel = getM2PerPaneel();
    var blockConfig = getBlockConfig(container);

    var wrapper = document.createElement('div');
    wrapper.className = REPLACEMENT_CLASS;
    wrapper.innerHTML = buildHTML(tiers, basePrice, m2PerPaneel, blockConfig);

    container.setAttribute(REPLACEMENT_MARKER, '1');
    container.style.display = 'none';

    if (container.parentNode) {
      container.parentNode.insertBefore(wrapper, container);
    }

    var mainPriceCtx = buildMainPriceContext(priceEl, tiers, function () {
      var qtyInput = findQuantityInput();
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    });

    injectClickStyles();
    attachClickHandlers(wrapper);
    syncActive(wrapper, mainPriceCtx);
    syncPrices(wrapper, priceEl, m2PerPaneel, mainPriceCtx);

    if (mainPriceCtx) {
      var bssWrapper = document.querySelector('.adeqo-product-info__price-wrapper');
      if (bssWrapper) {
        var bssObs = new MutationObserver(function () {
          if (mainPriceCtx.suppressObserver) return;
          var fresh = findVisiblePriceEl();
          if (fresh && fresh !== mainPriceCtx.priceEl) {
            mainPriceCtx.priceEl = fresh;
            var t = (fresh.textContent || '').trim();
            var p = parsePrice(t);
            if (p != null) mainPriceCtx.basePrice = p;
            var m = t.match(SUFFIX_REGEX);
            if (m) mainPriceCtx.suffix = ' ' + m[0];
            mainPriceCtx.lastSetText = null;
            mainPriceCtx.applyActive();
          }
        });
        bssObs.observe(bssWrapper, { childList: true, subtree: true, characterData: true, attributes: true });
      }

      setTimeout(function () { mainPriceCtx.applyActive(); }, 800);
      setTimeout(function () { mainPriceCtx.applyActive(); }, 2000);
    }

    var emptyPlaceholder = container.parentNode ? container.parentNode.querySelector('.bss-b2b-qb-table:empty') : null;
    if (emptyPlaceholder) emptyPlaceholder.style.display = 'none';
  }

  function scan() {
    var containers = document.querySelectorAll(TARGET_SELECTOR);
    containers.forEach(process);
  }

  function init() {
    scan();
    var observer = new MutationObserver(function () { scan(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
